import marketingBroadcastDispatcher from '../action';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0
  }
};

const marketingBroadcastReducer = marketingBroadcastDispatcher(initialState, {
  [marketingBroadcastDispatcher.getDataSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined
    }
  }),
  [marketingBroadcastDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value
  }),
  [marketingBroadcastDispatcher.resetData]: (state, _) => ({
    ...initialState
  })
});

export default marketingBroadcastReducer;
